/* eslint-disable */
import cx from 'classnames';
import changeCase from 'change-object-case';
import { connect } from 'react-redux'
import React, { Component } from 'react';
import { Button, Form, InputGroup, FormGroup, FormControl, Radio, ControlLabel, HelpBlock, Checkbox, Alert } from 'react-bootstrap';
import { ss, url, authJsonHeader, parseTimeString, mapDispatch } from '../../utils/util';
import Highlighter from "react-highlight-words";

import OzFormComponent from './OzFormComponent';
import WhereField from './WhereField';
import { AutocompleteField } from './EscapeForm';
import './AddToRegionForm.css';

import {
  listRegions
} from '../../actions';


class AddToRegionForm extends OzFormComponent {

  static fields = [
    'locationId',
    'regionId',
  ];

  componentDidMount() {
    this.props.listRegions();
  }

  renderBody() {
    let location = this.props.location;
    let regions = this.props.regions;
    if (!regions) return null;
    let regionOptions = regions.items.map(region => [region.id, region.name]);

    return (
      <div className="AddToRegionForm">
        <div>Adding this location:</div>
        <ul>
          <li>{location.company}</li>
          <li>{location.address}</li>
        </ul>
        {this.renderFormGroup('Region', 'select', 'regionId', regionOptions)}
      </div>
    );
  }
}


function mapStateToProps(state) {
  return {
    regions: state.list.region,
  };
}

function mapDispatchToProps(dispatch) {
  return mapDispatch(dispatch, {
    listRegions,
  });
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(AddToRegionForm);



/** WEBPACK FOOTER **
 ** ./src/components/partials/AddToRegionForm.js
 **/